import { useEffect, useState } from "react";
import { HERO_SLIDES } from "@/lib/business";

export default function HeroCarousel() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI(v => (v + 1) % HERO_SLIDES.length), 4500);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="relative" data-testid="hero-carousel">
      <div className="absolute -inset-2 rounded-[2rem] bg-gradient-to-br from-pink-100 via-white to-white blur-2xl opacity-70" aria-hidden />
      <div className="relative overflow-hidden rounded-3xl border border-pink-100 shadow-[0_18px_60px_rgba(229,0,125,0.18)] bg-white aspect-[4/3] sm:aspect-[4/3]">
        {HERO_SLIDES.map((s, idx) => (
          <img
            key={s.src}
            src={s.src}
            alt={s.alt}
            loading={idx === 0 ? "eager" : "lazy"}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ease-in-out ${i === idx ? "opacity-100" : "opacity-0"}`}
            data-testid={`hero-slide-${idx}`}
          />
        ))}
        {/* caption */}
        <div className="absolute left-3 bottom-3 right-3 flex items-center justify-between gap-2">
          <span className="inline-flex max-w-[75%] items-center gap-2 rounded-full bg-black/55 backdrop-blur px-3 py-1.5 text-white text-xs sm:text-sm shadow-sm">
            {HERO_SLIDES[i].caption}
          </span>
          <div className="flex items-center gap-1">
            {HERO_SLIDES.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                aria-label={`Slide ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-1.5 bg-white/60"}`}
                data-testid={`hero-dot-${idx}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
